import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";

import { SigninRoutingModule } from '@teem/features/auth/signin/signin-routing.module';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';
import { SigninComponent } from '@teem/features/auth/signin/signin.component';
// import { LoadingComponent } from '@teem/layouts/loading/loading.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


@NgModule({
  declarations: [
    SigninComponent,
    // LoadingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
		ReactiveFormsModule,
    NgxIntlTelInputModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    NiceSelectModule,
    SigninRoutingModule
  ]
})
export class SigninModule {
  
 }
